import "../../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { ref as u, reactive as x } from "../../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import { onUnmounted as A } from "../../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
function W(X = {}) {
  const {
    draggable: E = !0,
    initialX: L = 0,
    initialY: b = 0,
    dragThreshold: w = 5,
    excludeSelectors: D = []
  } = X, y = u(), s = u(!1), a = u(!1), r = x({ x: 0, y: 0 }), p = u(0), l = x({ x: 0, y: 0 }), e = x({ x: L, y: b }), m = () => {
    document.removeEventListener("mousemove", d, !0), document.removeEventListener("mouseup", h, !0), document.removeEventListener("mousemove", d), document.removeEventListener("mouseup", h);
  }, H = () => {
    const t = y.value;
    if (!t)
      return { width: 0, height: 0 };
    const n = t.getBoundingClientRect(), o = n.width || t.offsetWidth || 0, i = n.height || t.offsetHeight || 0;
    return { width: o, height: i };
  }, Y = (t, n) => {
    const { width: o, height: i } = H(), c = window.innerWidth, g = window.innerHeight, v = Math.max(0, c - o), f = Math.max(0, g - i);
    return {
      x: Math.max(0, Math.min(t, v)),
      y: Math.max(0, Math.min(n, f))
    };
  }, S = () => {
    const { x: t, y: n } = Y(e.x, e.y);
    e.x = t, e.y = n;
  }, B = (t) => {
    if (!E)
      return;
    const n = t.target;
    for (const o of D)
      if (n.closest(o))
        return;
    m(), a.value = !1, s.value = !1, r.x = t.clientX, r.y = t.clientY, p.value = e.y, l.x = t.clientX - e.x, l.y = e.y - (window.innerHeight - t.clientY), document.addEventListener("mousemove", d, !0), document.addEventListener("mouseup", h, !0);
  }, d = (t) => {
    const n = Math.abs(t.clientX - r.x), o = Math.abs(t.clientY - r.y);
    if ((n > w || o > w) && (s.value = !0, a.value = !0), !s.value)
      return;
    const i = t.clientX - l.x, c = window.innerHeight, g = c - t.clientY, v = c - r.y, f = g - v, T = p.value + f, M = Y(i, T);
    e.x = M.x, e.y = M.y;
  }, h = (t) => {
    m(), s.value = !1, setTimeout(() => {
      a.value = !1;
    }, 50);
  };
  return A(() => {
    m();
  }), {
    elementRef: y,
    position: e,
    isDragging: s,
    hasDragged: a,
    onDragStart: B,
    clampToViewport: S
  };
}
export {
  W as useDraggable
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/float-window/composables/useDraggable.js
// module id = 1287
// module chunks = 67